<script setup>
  import { computed } from 'vue'

  import LayoutSidebarSidebarToggle from '@/features/layout/components/LayoutSidebarSidebarToggle.vue'
  import SidebarPanelFooter from '@/features/layout/components/SidebarPanelFooter.vue'
  import SidebarPanelGroup from '@/features/layout/components/SidebarPanelGroup.vue'
  import { useLayoutStore } from '@/features/layout/useLayoutStore.js'

  const layoutStore = useLayoutStore()

  const classObject = computed(() => ({
    'sidebar-panel-show': layoutStore.sidebarOpened,
  }))

  const isLocalhost = computed(() => {
    return window.location.hostname === 'localhost'
  })

  const isTest = computed(() => {
    return window.location.hostname === 'test.frelloserver.com'
  })

  const isUat = computed(() => {
    return window.location.hostname === 'uat.frelloserver.com'
  })
</script>

<template>
  <div class="sidebar-panel" :class="classObject">
    <header
      class="sidebar-panel-header"
      :class="{
        centered: !layoutStore.sidebarOpened,
      }"
    >
      <span v-if="layoutStore.hamburgerLeftButton" class="hamburger-custom-button-desktop">
        <component :is="layoutStore.hamburgerLeftButton" />
      </span>

      <span class="hamburger-button-desktop">
        <LayoutSidebarSidebarToggle />
      </span>

      <span
        v-if="layoutStore.sidebarOpened"
        class="sidebar-club-name"
        data-test-id="sidebar-panel-header-text"
        v-tooltip.bottom="layoutStore.hamburgerTitle"
      >
        {{ layoutStore.hamburgerTitle }}
      </span>

      <Badge
        v-if="isLocalhost && layoutStore.sidebarOpened"
        severity="info"
        class="header-localhost-indicator-local"
      >
        local
      </Badge>

      <Badge
        v-if="isTest && layoutStore.sidebarOpened"
        severity="success"
        class="header-localhost-indicator-test"
      >
        test
      </Badge>

      <Badge
        v-if="isUat && layoutStore.sidebarOpened"
        severity="danger"
        class="header-localhost-indicator-uat"
      >
        uat
      </Badge>
    </header>

    <nav class="sidebar-panel-nav">
      <ul>
        <SidebarPanelGroup
          v-for="item of layoutStore.sidebarMenuItems"
          :key="item.to"
          :item="item"
        />
      </ul>
    </nav>

    <SidebarPanelFooter v-if="layoutStore.sidebarOpened" />
  </div>
</template>

<style lang="scss" scoped>
  .sidebar-panel {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: var(--fm-ui-sidebar-z-index);
    width: var(--fm-ui-sidebar-width);
    transition: all ease-in 0.2s;
    display: grid;
    grid-template-areas: 'header' 'nav' 'footer';
    grid-template-columns: 100%;
    grid-template-rows: auto 1fr auto;
    grid-auto-flow: dense;
    background: var(--fm-ui-sidebar-background-color);
    font-weight: 600;
  }

  header.sidebar-panel-header {
    grid-area: header;
    padding: 0 16px;
    border-bottom: 1px solid var(--fm-ui-sidebar-panel-inner-border);
    display: flex;
    gap: 16px;
    color: var(--fm-ui-sidebar-panel-header-color);
    align-items: center;
    height: var(--fm-ui-header-height);

    img {
      width: 80%;
    }

    &.centered {
      justify-content: center;
    }
  }

  nav.sidebar-panel-nav {
    display: flex;
    flex-direction: column;
    grid-area: nav;
    gap: 4px;

    ul {
      padding: 0;
      margin: 0;
      list-style: none;
    }
  }

  .sidebar-panel-show {
    left: 0;
  }

  .hamburger-button-desktop {
    cursor: pointer;
  }

  .sidebar-opened.show-sidebar .hamburger-custom-button-desktop {
    display: block;
  }

  .hamburger-custom-button-desktop {
    display: none;
  }

  .sidebar-club-name {
    @include truncateWithLines(1);
  }

  @include breakpoint('tablet') {
    .hamburger-custom-button-desktop {
      display: none;
    }

    .sidebar-panel-show .hamburger-custom-button-desktop {
      display: block;
    }
  }
</style>
